"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

exports.__esModule = true;

var plugin_1 = require("../api/plugin");

var shared_1 = require("../shared");

var Errors_1 = require("../../common/Errors");

var utils_1 = require("../../common/utils");

var Certificate_1 = require("./Certificate");

var _uniqBy = require("lodash/uniqBy");

var parse = require("date-fns/parse");

exports.ErrorCodes = {
  PluginCommand: 'PluginCommand',
  PluginTimeoutExpired: 'PluginTimeoutExpired'
};

var Plugin =
/** @class */
function () {
  function Plugin() {
    var _this = this;
    /**
     * В certProps не указываем hasPrivateKey, потому что определение этого свойства затратная операция,
     * Сертификат находится в контейнере значит hasPrivateKey у него true.
     */


    this.getCryptoProviderContainers = function (provider) {
      var certProps = {
        serialNumber: true,
        content: true,
        issuer: true,
        subject: true,
        validFrom: true,
        validTo: true,
        qualified: true,
        extensions: true,
        publicKeyLength: true,
        publicKeyAlgorithm: true
      };
      var command = {
        type: 'crypto.provider.getContainers',
        provider: provider,
        properties: {
          cert: certProps
        }
      };
      return _this.send(command).then(function (containers) {
        return containers.map(function (container) {
          if (container.cert) {
            container.cert.hasPrivateKey = true;
          }

          return container;
        });
      });
    };
  }

  Plugin.prototype.getInfo = function () {
    return this.send({
      type: 'plugin.info'
    }).then(function (result) {
      return {
        isInstalled: true,
        isBlocked: result.denied,
        version: result.pluginVersion,
        clientId: result.clientId || ''
      };
    })["catch"](function () {
      return {
        isInstalled: false,
        isBlocked: true,
        version: '',
        clientId: ''
      };
    });
  };

  Plugin.prototype.searchCertificate = function (searchQuery, certificateProperties) {
    var _this = this;

    if (certificateProperties === void 0) {
      certificateProperties = {};
    }

    var store = searchQuery.store,
        hash = searchQuery.hash,
        serialNumber = searchQuery.serialNumber,
        hasPrivateKey = searchQuery.hasPrivateKey,
        qualified = searchQuery.qualified,
        timeout = searchQuery.timeout;
    var filter = {
      qualified: qualified
    };

    if (hasPrivateKey) {
      filter.hasPrivateKey = hasPrivateKey;
    }

    if (store) {
      if (store.type) {
        filter.store = {
          storeType: store.type,
          name: store.name,
          location: store.location
        };
      } else {
        filter.storeName = store.name;
        filter.storeLocation = store.location;
      }
    }

    if (hash) {
      filter.hash = {
        type: 'hex',
        data: hash
      };
      filter.firstOnly = true;
    }

    if (serialNumber) {
      filter.serialNumber = {
        type: 'hex',
        data: serialNumber
      };
      filter.firstOnly = true;
    }

    var properties = __assign({
      serialNumber: true,
      content: true,
      issuer: true,
      subject: true,
      validFrom: true,
      validTo: true,
      hasPrivateKey: true,
      qualified: true,
      extensions: true,
      cryptoProvider: true,
      containerInfo: true,
      publicKeyLength: true,
      publicKeyAlgorithm: true
    }, certificateProperties);

    var commandExecuted = false;
    return new Promise(function (resolve, reject) {
      _this.send({
        type: 'cert.search',
        filter: filter,
        properties: properties
      }).then(function (arCertInfo) {
        commandExecuted = true;
        var certificates = arCertInfo.map(function (c) {
          try {
            return new Certificate_1["default"](c);
          } catch (error) {
            return null;
          }
        }).filter(utils_1.notEmpty);
        certificates = _uniqBy(certificates, function (c) {
          return c.thumbprint();
        });
        resolve(certificates);
      })["catch"](function (error) {
        commandExecuted = true;
        reject(error);
      });

      if (timeout) {
        setTimeout(function () {
          if (commandExecuted) {
            return;
          }

          reject(new Errors_1.CommonError('Plugin request timeout has expired', null, exports.ErrorCodes.PluginTimeoutExpired));
        }, timeout);
      }
    });
  };

  Plugin.prototype.decrypt = function (source, sink) {
    var command = {
      type: 'crypto.decrypt',
      source: source,
      sink: sink
    };
    return this.send(command)["catch"](function (error) {
      if (error.code === exports.ErrorCodes.PluginCommand) {
        switch (true) {
          case error.message.indexOf(shared_1.DecryptErrorMessages.CancelTokenInput) !== -1:
            {
              error.code = shared_1.DecryptErrors.CancelTokenInput;
              break;
            }

          case error.message.indexOf(shared_1.DecryptErrorMessages.CancelPinInput) !== -1:
            {
              error.code = shared_1.DecryptErrors.CancelPinInput;
              break;
            }

          case error.message.indexOf(shared_1.DecryptErrorMessages.WrongPin) !== -1:
            {
              error.code = shared_1.DecryptErrors.WrongPin;
              break;
            }

          default:
            {
              error.code = shared_1.DecryptErrors.NoSecretKeyContainer;
            }
        }
      }

      throw error;
    });
  };

  Plugin.prototype.encrypt = function (source, sink, certs) {
    var rawCertificates = certs.map(function (certificate) {
      return certificate.raw();
    });
    var command = {
      type: 'crypto.encrypt',
      source: source,
      sink: sink,
      certs: rawCertificates
    };
    return this.send(command);
  };

  Plugin.prototype.sign = function (options) {
    var certs = options.certs,
        source = options.source,
        sink = options.sink,
        rest = __rest(options, ["certs", "source", "sink"]);

    var rawCertificates = certs.map(function (cert) {
      return cert.raw();
    });

    var command = __assign({
      type: 'crypto.sign',
      source: source,
      sink: sink,
      certs: rawCertificates
    }, rest);

    return this.send(command);
  };

  Plugin.prototype.batchSign = function (options) {
    var certs = options.certs,
        source = options.source,
        sink = options.sink,
        rest = __rest(options, ["certs", "source", "sink"]);

    var rawCertificates = certs.map(function (cert) {
      return cert.raw();
    });

    var command = __assign({
      type: 'crypto.batch.sign',
      source: source,
      sink: sink,
      certs: rawCertificates
    }, rest);

    return this.send(command);
  };

  Plugin.prototype.displayCertificate = function (certificate) {
    var command = {
      type: 'cert.display',
      cert: certificate.raw()
    };
    return this.send(command);
  };

  Plugin.prototype.searchCryptoProviders = function (cryptoProviderType) {
    var command = {
      type: 'crypto.provider.search'
    };

    if (cryptoProviderType) {
      command.cryptoProviderType = cryptoProviderType;
    }

    return this.send(command);
  };

  Plugin.prototype.getCryptoProLicense = function (guid) {
    var command = {
      type: 'crypto.provider.cryptopro.getLicense',
      guid: guid
    };
    return this.send(command).then(function (licenseString) {
      return parse(licenseString);
    });
  };

  Plugin.prototype.installCertificate = function (containerCertInfo, options) {
    var certificate = containerCertInfo.certificate,
        provider = containerCertInfo.provider,
        name = containerCertInfo.name;
    var storeName = options.storeName,
        storeLocation = options.storeLocation,
        force = options.force;

    var cryptoProviderInstallInfo = __assign({}, provider, {
      containerName: name,
      storeName: storeName,
      storeLocation: storeLocation
    });

    var command = {
      type: 'crypto.installCert',
      cert: {
        type: 'base64',
        data: certificate.toBase64()
      },
      cryptoProvider: cryptoProviderInstallInfo,
      force: force
    };
    return this.send(command);
  };

  Plugin.prototype.close = function () {
    try {
      if (plugin_1.plugin.close) {
        plugin_1.plugin.close();
      } // tslint:disable-next-line

    } catch (e) {}
  };

  Plugin.prototype.send = function (command) {
    return new Promise(function (resolve, reject) {
      var commandId = plugin_1.plugin.send(command, function (error, result) {
        if (error) {
          var info = "Command id=" + commandId + ", command type=" + command.type + ". Message: " + error.message;
          var message = "Error occurred during execution of plugin command. " + info;
          return reject(new Errors_1.CommonError(message, null, exports.ErrorCodes.PluginCommand, error));
        }

        resolve(result);
      });
    });
  };

  return Plugin;
}();

exports.Plugin = Plugin;